export default __webpack_public_path__ + "static/media/diego-torres-transformation.35af7107.jpeg";